import React, { Suspense, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoadingPage from "./components/LoadingPage";
import { PengajuanState } from "./context/Context";

const LandingPage = React.lazy(() => import("./pages/landingPage"));
const MitraListPage = React.lazy(() => import("./pages/mitraListPage"));
const PengajuanMedia = React.lazy(() => import("./pages/pengajuanMedia"));
const InfoPengajuan = React.lazy(() => import("./pages/infoPengajuan"));
const Faq = React.lazy(() => import("./pages/faq"));

function App() {
  const { tanggalStatus } = PengajuanState();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    getData();
  }, [tanggalStatus]);

  const getData = () => {
    const value = window.localStorage.getItem("status");
    if (value !== null) {
      setStatus(value);
    }
  };

  return (
    <Router>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/faq" element={<Faq />} />
          <Route
            path="/list-media"
            element={
              status === "pengumuman" ? (
                <MitraListPage />
              ) : (
                tanggalStatus && <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/pengajuan-media"
            element={
              status === "pendaftaran" ? (
                <InfoPengajuan />
              ) : (
                tanggalStatus && <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/pengajuan"
            element={
              status === "pendaftaran" ? (
                <PengajuanMedia />
              ) : (
                tanggalStatus && <Navigate replace to="/" />
              )
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
